import FormAlbaran from '../componentes/FormAlbaran.vue'
import ListaAlbaranes from '../componentes/ListaAlbaranes.vue'

const meta_albaran ={
    Auth:true,
    lista:'/lista-albaranes',
    guardar:'/guardar-albaran',
    guardar_contrario:'/guardar-albaran-especial',

    especial:0,
}
const meta_albaran_especial ={
    Auth:true,
    lista:'/lista-albaranes-especiales',
    guardar:'/guardar-albaran-especial',
    guardar_contrario:'/guardar-albaran',
    especial:1,
}
const routes = [
    ...route('/guardar-albaran', FormAlbaran, meta_albaran),
     ...route('/lista-albaranes', ListaAlbaranes, meta_albaran),
     ...route('/guardar-albaran-especial', FormAlbaran, meta_albaran_especial),
     ...route('/lista-albaranes-especiales', ListaAlbaranes, meta_albaran_especial)
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes